{
  "name": "react-email-editor",
  "version": "2.1.2",
  "description": "Unlayer's Email Editor Component for React.js",
  "type": "commonjs",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.mts",
        "default": "./dist/index.mjs"
      },
      "require": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    },
    "./package.json": "./package.json"
  },
  "sideEffects": false,
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=18"
  },
  "scripts": {
    "start": "tsup --watch",
    "build": "tsup",
    "test": "vitest run",
    "test:legacy": "vitest run --config vitest.legacy.config.ts",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit",
    "lint": "prettier --check .",
    "format": "prettier --write .",
    "prepare": "npm run build",
    "release": "npm run build && npm publish",
    "netlify-build": "cd demo && npm install && npm run build"
  },
  "peerDependencies": {
    "react": ">=16.8"
  },
  "dependencies": {
    "@unlayer/types": "^1.448.0"
  },
  "devDependencies": {
    "@testing-library/react": "^16.3.2",
    "@types/react": "^19.2.17",
    "@types/react-dom": "^19.2.3",
    "@vitest/coverage-v8": "^4.1.10",
    "jsdom": "^29.1.1",
    "prettier": "^3.9.4",
    "react": "^19.2.0",
    "react-dom": "^19.2.0",
    "tsup": "^8.5.1",
    "typescript": "^6.0.3",
    "vitest": "^4.1.10"
  },
  "overrides": {
    "esbuild": "^0.28.2",
    "postcss": "^8.5.26",
    "nanoid": "^3.3.17",
    "undici": "^7.29.0"
  },
  "author": "Unlayer",
  "homepage": "https://github.com/unlayer/react-email-editor#readme",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/unlayer/react-email-editor.git"
  },
  "keywords": [
    "react",
    "react-component",
    "email",
    "email-editor",
    "email-builder",
    "drag-and-drop",
    "unlayer",
    "wysiwyg"
  ]
}
